module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-header-2000x775.e9e85df.jpg";